// extracted by mini-css-extract-plugin
module.exports = {"formSection":"ImageLP_formSection__gMMkJ","formWrapper":"ImageLP_formWrapper__YyXM2","fixedFormWrapper":"ImageLP_fixedFormWrapper__Gizoh"};